import React from 'react'
import { SocialButton } from './SocialButton'

export const ShareOnHackerNews = ({ frontmatter, ...rest }) => {
  const title = encodeURI(frontmatter.title)
  const url = encodeURI(`https://community.hetzner.com${frontmatter.path}`)
  return (
    <SocialButton
      as={'a'}
      target={'_blank'}
      rel={'noopener noreferrer'}
      className='d-flex link-unstyled box-shadow-none'
      href={`https://news.ycombinator.com/submitlink?t=${title}&u=${url}`}
      { ...rest }
    >
      <i className='fa fa-y-combinator' />
    </SocialButton>
  )
}
